import React, {PropTypes} from 'react';
import {Button, TextField} from '@goguardian/based';
import Loading from '_shared/components/loading';
import validateEmailBasic from '_shared/lib/validate-email-basic';

import style from './style.scss';

export default class AdminEmail extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      doSave: false,
      adminEmail: null,
      validEmail: null
    };
  }

  updateEmail(value) {
    this.setState({
      adminEmail: value
    });
  }

  sendEmail() {
    // In the past, floor-warden (this service's API) would look up
    // the requester's GG org if no email was provided here and the requester was
    // a valid GG user already -- it would then email the first super admin on
    // that org's list. That is no longer the case -- if implicit lookups must be
    // supported in the future this validation should be removed.
    const validEmail = validateEmailBasic(this.state.adminEmail);
    this.setState({
      doSave: validEmail,
      validEmail
    });
  }

  renderForm() {

    return (
      <div className={style.ITContainer}>
        <h1>Almost there...</h1>
        <p>
          Your account doesn't have the necessary permissions to complete sign up,
          but not to worry: enter your IT Administrator's email below, and we'll contact
           them to complete sign-up.
        </p>
        <div className={style.accountForm}>
          <TextField
            label="IT ADMINISTRATOR’S EMAIL ADDRESS"
            onChange={this.updateEmail.bind(this)}
            value={this.state.adminEmail}
            className={style.textField}
            block/>
        </div>
        <Button onClick={this.sendEmail.bind(this)}>
          Send
        </Button>
      {this.state.validEmail === false && <div className={style.error}>
        Please provide a valid email.
        </div>}
      </div>
    );
  }

  renderLoader() {
    return (
      <Loading actionName="contactAdmin" actionParams={[this.state.adminEmail]}>
        We are contacting your IT Administrator...
      </Loading>
    )
  }

  render() {
    return this.state.doSave ? this.renderLoader() : this.renderForm();
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/adminEmail/index.jsx
 **/